import { strings } from "res";
import { DashboardIcon, OrderIcon, ReportIcon } from "../assets/svg/icon";
import {
  UserOutlined,
  TagOutlined,
  BranchesOutlined,
  FileOutlined,
  MessageFilled,
  ProfileOutlined,
  AccountBookOutlined,
} from "@ant-design/icons";

const dashBoardNavTree = [
  {
    key: "Home",
    path: strings.navigation.path.dashboard,
    title: "Home",
    breadcrumb: false,
    submenu: [
      {
        key: "Dashboard",
        path: strings.navigation.path.dashboard,
        title: "Dashboard",
        icon: DashboardIcon,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "Menu",
        path: strings.navigation.path.menu,
        title: "Menu",
        icon: FileOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "Tipe Menu",
        path: strings.navigation.path.menu_type,
        title: "Tipe Menu",
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "Produk",
        path: strings.navigation.path.products,
        title: "Produk",
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "Reservasi",
        path: strings.navigation.path.reservasi,
        title: "Reservasi",
        icon: MessageFilled,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "Blogs",
        path: strings.navigation.path.contents,
        title: "Blogs",
        icon: AccountBookOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "Kategori",
        path: strings.navigation.path.categories,
        title: "Kategori",
        icon: OrderIcon,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "Sub Kategori",
        path: strings.navigation.path.subcategories,
        title: "Sub Kategori",
        icon: BranchesOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "User",
        path: strings.navigation.path.users,
        title: "User",
        icon: UserOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

// const ControlTree = [{
//   key: "Pengaturan",
//   path: strings.navigation.path.settings,
//   title: "Pengaturan",
//   breadcrumb: false,
//   submenu: [
//     {
//       key: "Pengaturan",
//       path: strings.navigation.path.settings,
//       title: "Pengaturan",
//       icon: SettingIcon,
//       breadcrumb: false,
//       submenu: []
//     }
//   ]
// }]

const navigationConfig = [
  ...dashBoardNavTree,
  // ...ControlTree,
];

export default navigationConfig;
